import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import RedirectToHome from '../../components/RedirectToHome';
import { routes } from './routes';
import { WorkflowsNav } from './WorkflowsNav';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';

export const WorkflowsMainPage: React.FC = () => {
  const { t } = useTranslation();

  useFlairBreadcrumbHook([
    { label: t('navigation.menuItems.tasks.title') },
    { label: t('performanceReview.workflows.title') },
  ]);

  return (
    <>
      <PageHeader title={t('performanceReview.workflows.title')}>
        <WorkflowsNav />
      </PageHeader>
      <Content />
    </>
  );
};

const Content: React.FC = () => (
  <Switch>
    {Object.values(routes()).map(({ render, route }, i) => (
      <Route
        key={i}
        exact={true}
        path={route.template()}
        render={() => render()}
      />
    ))}
    <Route path="*">
      <RedirectToHome />
    </Route>
  </Switch>
);
